import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";

const ProtectedRouteAdmin = ({ children }) => {
  const token = sessionStorage.getItem("token");
  const role = sessionStorage.getItem("role");

  if (!token || role !== "ADMIN") {
    return <Navigate to="/authentication/sign-in" replace />;
  }

  return children;
};

ProtectedRouteAdmin.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRouteAdmin;
